<template>
  <div>
    <CContainer>
      <CRow class="justify-content-center mt-4">
        <CCol md="12 text-center">
          <StudentConsequencesLadderTable></StudentConsequencesLadderTable>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import { onMounted } from "vue"
import { useI18n } from "vue-i18n"
import StudentConsequencesLadderTable from "@/v3components/Datatables/StudentConsequencesLadderTable.vue"

export default {
  components: { StudentConsequencesLadderTable },
  name: "ConsequencesLadder",
  setup() {
    const { t } = useI18n()

    onMounted(() => {
      document.title = `${t("sidebar_items.consequences_ladder")} · Securly Pass`
    })

    return {}
  }
}
</script>
